import {
  Patient,
  IPatientRepository,
} from "../../../domain/patient";
import { AuthenticatedService } from "../..";
import { IPatientBean, IPatientDuplicateInformationBean } from "./beans";
import Enumerable from "linq";

export class PatientRepository extends AuthenticatedService implements IPatientRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getEntity(id: string): Promise<Patient> {
    const url = "/api/patient/" + id;
    const result = await this.get(url);
    return this.toPatient(result.data);
  }

  toPatient(bean: IPatientBean): Patient {
    const patient = new Patient(bean.patientId, bean.name, bean.kanaName, this.toDate(bean.birthDate), bean.sex);
    Object.freeze(patient);
    return patient;
  }

  private toDate(date: string): Date {
    if (!date) { return null; }
    try {
      return new Date(date);
    } catch (e) {
      console.warn(e);
    }
    return null;
  }

  async serachByName(name: string): Promise<Patient[]> {
    if (!name) { throw new Error("name is empty!!!"); }
    const url = "/api/patients";
    const query = {
      params: {
        token: this.token,
        name,
      }
    };
    const result = await this.get(url, query);
    return this.toPatients(result.data);
  }

  private toPatients(beans: IPatientBean[]): Patient[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toPatient(bean));
  }

  async hasDuplicatedPatientId(id: string): Promise<boolean> {
    const url = "/api/patient/" + id + "/duplicate-information";
    const result = await this.get(url);
    const beans = result.data as IPatientDuplicateInformationBean[];
    if (!beans) { return false; }
    return Enumerable.from(beans).any(bean => bean.patientId !== id);
  }

  async getDuplicatedPatients(id: string): Promise<Patient[]> {
    const url = "/api/patient/" + id + "/duplicate-information";
    const result = await this.get(url);
    const beans = result.data as IPatientDuplicateInformationBean[];
    if (!beans) { return []; }

    // TODO: 数が多いようであれば、API側でまとめて取得したほうがよさそう
    const patients: Patient[] = [];
    for (const bean of beans) {
      const patient = await this.getEntity(bean.patientId);
      patients.push(patient);
    }
    return patients;
  }
}
